import type { GroupTraits, UserTraits } from '@segment/analytics-next';

import { SegmentConfig } from '../config/segment-config';

import type { AnalyticsTransport } from './analytics-transport';

export interface SegmentTransportOptions {
  writeKey: string;
  disableClientPersistence?: boolean;
}

export class SegmentTransport implements AnalyticsTransport {
  private readonly analytics: SegmentConfig;

  constructor({ writeKey, disableClientPersistence }: SegmentTransportOptions) {
    this.analytics = new SegmentConfig({ writeKey, enabled: true, disableClientPersistence });
  }

  track(eventName: string, properties?: Record<string, unknown>) {
    this.analytics.track(eventName, properties);
  }

  page(name: string, properties?: Record<string, unknown>) {
    this.analytics.page(name, properties);
  }

  identify(userId: string, traits?: UserTraits) {
    this.analytics.identify(userId, traits);
  }

  group(groupId: string, traits?: GroupTraits) {
    this.analytics.group(groupId, traits);
  }

  async getAnonymousId() {
    const user = await this.analytics.user();
    return user.anonymousId() ?? null;
  }

  reset() {
    this.analytics.reset();
  }

  setDeviceId(id: string) {
    this.analytics.setAnonymousId(id);
  }

  startSessionReplay() {}

  stopSessionReplay() {}
}
